export const User = {
  statuses: {
    Guest: 'guest',
  },
};
